module.exports = __webpack_public_path__ + "img/KC_YY.98f2ad84.png";